import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import { useTranslation } from 'react-i18next';
import FontFamily from '../../constants/fonts';
import { AdminColors } from '../Admin/constants/adminColors';
import { useDarkStyles } from '../../theme/useDarkStyles';

const LANGUAGES = [
  { code: 'en', label: 'EN' },
  { code: 'fr', label: 'FR' },
  { code: 'es', label: 'ES' },
];

interface PTLanguageToggleProps {
  compact?: boolean; // smaller padding for mobile
}

const PTLanguageToggle: React.FC<PTLanguageToggleProps> = ({ compact = false }) => {
  const styles = useDarkStyles(baseStyles);
  const { i18n } = useTranslation('perfectTruck');
  const currentLang = (i18n.language ?? 'en').split('-')[0];

  const handleChange = (lang: string) => {
    i18n.changeLanguage(lang);
    try {
      if (typeof window !== 'undefined') {
        localStorage.setItem('pt_language', lang);
      }
    } catch {
      // localStorage unavailable (e.g. native)
    }
  };

  return (
    <View style={styles.container}>
      {LANGUAGES.map((lang, idx) => {
        const isActive = currentLang === lang.code;
        return (
          <TouchableOpacity
            key={lang.code}
            style={[
              styles.btn,
              compact && styles.btnCompact,
              idx === 0 && styles.btnLeft,
              idx === LANGUAGES.length - 1 && styles.btnRight,
              isActive && styles.btnActive,
            ]}
            onPress={() => handleChange(lang.code)}
            activeOpacity={0.75}
          >
            <Text style={[styles.label, isActive && styles.labelActive]}>
              {lang.label}
            </Text>
          </TouchableOpacity>
        );
      })}
    </View>
  );
};

const baseStyles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    borderWidth: 1.5,
    borderColor: AdminColors.borderDefault,
    borderRadius: 8,
    overflow: 'hidden',
  },
  btn: {
    paddingHorizontal: 12,
    paddingVertical: 6,
    backgroundColor: AdminColors.bgSurface,
  },
  btnCompact: {
    paddingHorizontal: 9,
    paddingVertical: 4,
  },
  btnLeft: {
    borderRightWidth: 1,
    borderRightColor: AdminColors.borderDefault,
  },
  btnRight: {},
  btnActive: {
    backgroundColor: AdminColors.blue700,
  },
  label: {
    fontFamily: FontFamily.bold,
    fontSize: 11,
    color: AdminColors.textSecondary,
    letterSpacing: 0.4,
  },
  labelActive: {
    color: AdminColors.textOnDark,
  },
});

export default PTLanguageToggle;
